app.service("cookieService", ["$cookies", function($cookies) {

  var validCookies                = ['c_firebaseid', 'c_loggedin', 'c_username', 'c_usertype', 'c_firstname', 'c_lastname', 'c_userid', 'c_authlevel', 'c_sourceURL', 'c_rememberme', 'c_active'];
  var c_loggedin                  = false;
  var c_firebaseid                = "";
  var c_username                  = "";
  var c_usertype                  = "";
  var c_firstname                 = "";
  var c_lastname                  = "";
  var c_userid                    = 0;
  var c_authlevel                 = 0;
  var c_sourceURL                 = "";
  var c_rememberme                = false;
  var c_active                    = false;
  var c_intercom_articles_wizards = ""

  var expireDate = new Date();
  expireDate.setDate(expireDate.getDate() + 90);

  return {

    // section for Intercom articles -------------------------
    setIntercomArticles_Wizards:
      function(value) {
        c_intercom_articles_wizards = value;
        $cookies.put("c_intercom_articles_wizards", value);
        return true;
      },
    getIntercomArticles_Wizards:
      function() {
        return $cookies.get("c_intercom_articles_wizards");
      },     

    clearIntercomArticles_Wizards:
      function() {
        c_intercom_articles_wizards = "";
        $cookies.remove("c_intercom_articles_wizards");
        return true;
      },
    // END: section for Intercom articles---------------------

    setCookieDataByArray:
      function (keys, values) {
        for (var i=0; i<keys.length; i++) {
          if (validCookies.indexOf(keys[i])>-1) {
            $cookies.put(keys[i], values[i], { 'expires': expireDate });
          }
        }
        return true;
      },

    setCookieSourceURL:
      function(URL) {
        c_sourceURL = URL;
        $cookies.put("c_sourceURL", URL);
        return true;
      },

      getCookieSourceURL:
        function() {
          return $cookies.get("c_sourceURL");
        },

      clearCookieSourceURL:
        function() {
          c_sourceURL = "";
          $cookies.remove("c_sourceURL");
          return true;
        },

    setCookieData:
      function(loggedin, obj) {
        c_loggedin   = loggedin;
        c_username   = obj.username;
        c_usertype   = obj.usertype;        
        c_firstname  = obj.first_name;
        c_lastname   = obj.last_name;        
        c_userid     = obj.userid;
        c_authlevel  = obj.authlevel;
        c_rememberme = obj.rememberme;
        c_active     = obj.active;
        c_firebaseid = obj.firebase_id
        $cookies.put("c_loggedin",    c_loggedin,   {'expires': expireDate});
        $cookies.put("c_firebaseid",  c_firebaseid, {'expires': expireDate});
        $cookies.put("c_username",    c_username,   {'expires': expireDate});
        $cookies.put("c_usertype",    c_usertype,   {'expires': expireDate});
        $cookies.put("c_firstname",   c_firstname,  {'expires': expireDate});
        $cookies.put("c_lastname",    c_lastname,   {'expires': expireDate});        
        $cookies.put("c_userid",      c_userid,     {'expires': expireDate});
        $cookies.put("c_authlevel",   c_authlevel,  {'expires': expireDate});
        $cookies.put("c_rememberme",  c_rememberme, {'expires': expireDate});
        $cookies.put("c_active",      c_active,     {'expires': expireDate});
        return true;
      },

    getCookieData:
      function(cookieName) {
        return $cookies.get(cookieName);
      },

    setCookieDataNode:
      function(cookieName, data) {
        $cookies.put(cookieName, data, {'expires': expireDate} );
        return true;
      },

    clearCookieData:
      function(cookieName) {
        $cookies.remove(cookieName);
        return true;
      },

    getAllCookieData:
      function() {
        var cookieData            = {};
            cookieData.loggedin   = $cookies.get("c_loggedin")=='true'?true:false;
            cookieData.firebaseid = $cookies.get("c_firebaseid");
            cookieData.username   = $cookies.get("c_username");
            cookieData.usertype   = $cookies.get("c_usertype");
            cookieData.first_name = $cookies.get("c_firstname");
            cookieData.last_name  = $cookies.get("c_lastname");
            cookieData.userid     = Number($cookies.get("c_userid"));
            cookieData.authlevel  = Number($cookies.get("c_authlevel"));
            cookieData.rememberme = $cookies.get("c_rememberme")=='true'?true:false;
            cookieData.active     = $cookies.get("c_active");
        return cookieData;
      },

    clearCookieData:
      function() {
        c_loggedin   = false;
        c_firebaseid = "";
        c_username   = "";
        c_usertype   = "";
        c_firstname  = "";
        c_lastname   = "";
        c_userid     = 0;
        c_authlevel  = 0;
        c_rememberme = false;
        c_active     = false;
        $cookies.remove("c_loggedin");
        $cookies.remove("c_firebaseid");
        $cookies.remove("c_username");
        $cookies.remove("c_usertype");
        $cookies.remove("c_firstname");
        $cookies.remove("c_lastname");
        $cookies.remove("c_userid");
        $cookies.remove("c_authlevel");
        $cookies.remove("c_rememberme");
        $cookies.remove("c_active");
        return true;
      }

  };
}]);
